import { Card, Form, Typography, Divider } from 'antd'
import { BrandingForm } from './Settings/BrandingForm'
import { DocumentSettings } from './Settings/DocumentSettings'

const { Title } = Typography

export const SettingsPanel = () => {
  return (
    <Card className="h-full">
      <Title level={4}>Document Settings</Title>

      <Form layout="vertical">
        <BrandingForm />
        <Divider />
        <DocumentSettings />
      </Form>
    </Card>
  )
}
